import { BaseRouteService } from 'core/services';

class OrderRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'orders/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}

	getUnlinkedOrderLines(filter) {
		return super.create(this.base + 'unlinked', filter);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	replace(replaceParams, sourceOfChange) {
		return super.get(this.base + 'replacement/sourceOfChange={sourceOfChange}', replaceParams, { sourceOfChange });
	}

	createOrdersBulk(resource, sourceOfChange) {
		return super.create(this.base + 'create-orders-bulk/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	}

	validateOrderAddress(resource) {
		return super.update(this.base + 'verify-order-address', resource);
	}

	updateOrderInfo(resource, sourceOfChange) {
		return super.update(this.base + 'update-order-info/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	}
}

export default OrderRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/OrderRouteService.js